import { RequestPoolManager } from './requestPoolManager.js';
import RequestType from '../enums/RequestType.js';
const imageLoadPoolManager = new RequestPoolManager('imageLoadPool');
imageLoadPoolManager.grabDelay = 0;
imageLoadPoolManager.setMaxSimultaneousRequests(RequestType.Interaction, 1000);
imageLoadPoolManager.setMaxSimultaneousRequests(RequestType.Thumbnail, 1000);
imageLoadPoolManager.setMaxSimultaneousRequests(RequestType.Prefetch, 1000);
export default imageLoadPoolManager;
